import PlainDate from '@Domain/PlainDate';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';

type StoredValue = string | number | boolean | readonly string[] | null;

const labelOf = (definition: SubjectFieldDefinitionView, value: string): string =>
	definition.options.find((option) => option.value === value)?.label ?? value;

/** The text shown for a stored value, `null` when the field has none. */
const formatFieldValue = (definition: SubjectFieldDefinitionView, value: StoredValue): string | null => {
	if (value === null) {
		return null;
	}

	switch (definition.nature) {
		case 'date':
			return typeof value === 'string'
				? (PlainDate.fromApi(value)?.toCalendar().toLocaleDateString('fr-FR') ?? null)
				: null;
		case 'number':
			return typeof value === 'number' ? value.toLocaleString('fr-FR') : null;
		case 'boolean':
			return typeof value === 'boolean' ? (value ? 'Oui' : 'Non') : null;
		case 'choice':
			return typeof value === 'string' ? labelOf(definition, value) : null;
		case 'multiple_choice':
			return Array.isArray(value) && value.length > 0
				? value.map((entry) => labelOf(definition, entry)).join(', ')
				: null;
		default:
			return typeof value === 'string' && value !== '' ? value : null;
	}
};

export default formatFieldValue;
